// Комментарий на русском: офлайн-хранилище чатов через IndexedDB.
// Зачем: пользователь должен видеть ранее загруженные диалоги/сообщения без сети и хранить очередь исходящих.

const DB_NAME = 'lisad_chat_offline_v1';
const DB_VERSION = 1;
const STORE = 'kv';

type KvRow<T = unknown> = { k: string; v: T; ts: number };

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') return reject(new Error('indexedDB_unavailable'));
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: 'k' });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error || new Error('indexedDB_open_failed'));
  });
}

function asPromise<T>(req: IDBRequest<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error || new Error('indexedDB_request_failed'));
  });
}

export async function chatKvGet<T>(key: string): Promise<null | { value: T; ts: number }> {
  try {
    const db = await openDb();
    const tx = db.transaction(STORE, 'readonly');
    const store = tx.objectStore(STORE);
    const row = (await asPromise(store.get(key))) as KvRow<T> | undefined;
    return row && typeof row.k === 'string' ? { value: row.v as T, ts: Number(row.ts || 0) || 0 } : null;
  } catch {
    return null;
  }
}

export async function chatKvSet<T>(key: string, value: T): Promise<void> {
  try {
    const db = await openDb();
    const tx = db.transaction(STORE, 'readwrite');
    const store = tx.objectStore(STORE);
    await asPromise(store.put({ k: key, v: value, ts: Date.now() } as KvRow<T>));
  } catch {
    // ignore
  }
}

export async function chatKvDel(key: string): Promise<void> {
  try {
    const db = await openDb();
    const tx = db.transaction(STORE, 'readwrite');
    const store = tx.objectStore(STORE);
    await asPromise(store.delete(key));
  } catch {
    // ignore
  }
}

export async function chatKvClearUser(userId: number): Promise<void> {
  const uid = Number(userId || 0) || 0;
  if (!uid) return;
  const prefix = `u:${uid}:`;
  try {
    const db = await openDb();
    const tx = db.transaction(STORE, 'readwrite');
    const store = tx.objectStore(STORE);
    await new Promise<void>((resolve) => {
      const cur = store.openCursor();
      cur.onsuccess = () => {
        const c = cur.result;
        if (!c) return resolve();
        const k = String((c.key as any) || '');
        if (k.startsWith(prefix)) c.delete();
        c.continue();
      };
      cur.onerror = () => resolve(); // best-effort
    });
  } catch {
    // ignore
  }
}

export async function chatDeleteDb(): Promise<void> {
  try {
    if (typeof indexedDB === 'undefined') return;
    indexedDB.deleteDatabase(DB_NAME);
  } catch {
    // ignore
  }
}


